export default "__VITE_ASSET__9d1dab74__"